<script lang="ts">
    import { mdiChevronRight, mdiChevronDown, mdiCheck, mdiAlert } from "@mdi/js"
    import { RuleEngine } from "../RuleEngine"
    import { setObjectValuesToNull } from "../utils"

    import { tooltip } from "../../../../utils"
    import Icon from "../../../widgets/Icon.svelte"
    import StepSubField from "./StepSubField.svelte"
    import { writable } from "svelte/store"
    interface Props extends StepComponentProps {
        onCompleted?: (value: boolean) => void
        selected?: string
    }
    let {
        ftpAssetsUrl,
        currentChoices = null,
        value = $bindable(),
        name = null,
        stepCompletedDependsOn,
        dependsOn,
        label,
        subFields = [],
        selected = $bindable(),
        values = $bindable(),
        onCompleted,
    }: Props = $props()

    let selectedB = $derived(selected == name)
    let stepEntered = $state(false)

    values = values || null
    if (!value) value = {}

    const ruleEngine = new RuleEngine()
    let invalidConfig = $state(false)

    let displayComponent: boolean = $derived(dependsOn && values ? ruleEngine.resolve(dependsOn, values) : true)
    let stepCompleted = $derived(
        stepCompletedDependsOn && values ? ruleEngine.resolve(stepCompletedDependsOn, values) : false
    )
    $effect(() => {
        if (selectedB) stepEntered = true
    })
    $effect(() => {
        if (stepCompleted && (stepEntered || selectedB)) onCompleted(true)
        else if (!stepCompleted) onCompleted(false)
        if (invalidConfig) onCompleted(false)
    })

    $effect(() => {
        if (!displayComponent) setObjectValuesToNull(value)
    })
</script>

{#if displayComponent}
    {#key selectedB}
        <!-- svelte-ignore a11y_click_events_have_key_events -->
        <div
            class="nav-item {name}"
            role="button"
            tabindex="0"
            onclick={() => (selected = name)}
            class:selected={selectedB}
            class:invalid={invalidConfig}
            class:completed={stepCompleted && (stepEntered || selectedB)}
        >
            <div class="title">
                {#if invalidConfig}
                    <div
                        use:tooltip={{
                            content: "Die zuvor gewählten Optionen sind ungültig für die aktuelle Konfiguration!",
                        }}
                    >
                        <Icon path={mdiAlert} size="1.2rem" />
                    </div>
                {:else if stepCompleted && (stepEntered || selectedB)}
                    <Icon path={mdiCheck} size="1.2rem" />
                {/if}
                {label ? label : "..."}
                <div class="chevron">
                    <Icon path={selectedB ? mdiChevronDown : mdiChevronRight} />
                </div>
            </div>
        </div>
    {/key}
    {#if subFields.length}
        <div class="config" class:hidden={!selectedB}>
            {#each subFields as field}
                <StepSubField
                    {field}
                    {values}
                    bind:value
                    {currentChoices}
                    onInvalidConfig={(b) => {
                        setTimeout(() => {
                            invalidConfig = b
                            if (b) value[field.name] = null
                        }, 0)
                    }}
                    {ftpAssetsUrl}
                />
            {/each}
        </div>
    {/if}
{/if}
